import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { SiteCopyrightBar } from '../SiteCopyrightBar';
import { CWY_COLORS } from '../../theme/colors';

/** Minimal shell for auth and standalone pages — copyright on every screen. */
export const AuthLayout: React.FC = () => (
  <Box
    sx={{
      minHeight: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: CWY_COLORS.pageBg,
    }}
  >
    <Box component="main" sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Outlet />
    </Box>
    <SiteCopyrightBar />
  </Box>
);
